import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafePureComponent from '../shared/SafePureComponent';
import { REVIEWS } from '../../utils/pageSections';
import { validateOverview } from '../../utils/mainComponentsValidator';
import OverviewProfileImage from './ProfileImage';
import Breadcrumbs from './Breadcrumbs';

import './style.scss';

class GigOverview extends Component {

    constructor(props) {
        super(props);

        this.onReviewsClick = this.onReviewsClick.bind(this);
    }

    onReviewsClick() {
        this.props.scrollToSection({sectionKey: REVIEWS});
    }

    getTitlePrefixKey() {
        const { general } = this.context;
        const { isStudio } = general;
        const key = isStudio ? 'our_studio_will' : 'i_will';

        return <I18n k={`gig_page_perseus.general.${key}`}/>;
    }

    showFiverrChoiceBadge() {
        const { params } = this.context.requestContext;
        const { isFiverrChoice } = this.props.overview.gig;

        return isFiverrChoice && params.fiverr_choice;
    }

    showUserInfo() {
        const { ordersInQueue, ratingsCount } = this.props.overview.gig;
        const showOrdersInQueue = ordersInQueue > 0;
        const showRating = ratingsCount > 0;

        return showRating || showOrdersInQueue || this.showFiverrChoiceBadge();
    }

    render() {
        const { overview, useStickyLayout, scrollToSection, studioInfo } = this.props;

        // todo: maintain error
        if (!validateOverview({overview, error: false})) {
            return null;
        }

        const { gig, categories, seller } = overview;
        const { ordersInQueue, ratingsCount, rating, title } = gig;
        const showOrdersInQueue = ordersInQueue > 0;
        const showRating = ratingsCount > 0;
        const showFiverrChoiceBadge = this.showFiverrChoiceBadge();
        const showUserInfo = this.showUserInfo();

        return (
            <div className="gig-overview">
                <Breadcrumbs categories={categories}/>
                <h1>{this.getTitlePrefixKey()} {title}</h1>
                <div className="seller-overview">
                    <OverviewProfileImage seller={seller} studioInfo={studioInfo}
                        scrollToSection={scrollToSection}
                        useStickyLayout={useStickyLayout}/>
                    {showUserInfo &&
                        <div className="user-info">
                            {showRating &&
                                <span className="user-info-rating" onClick={this.onReviewsClick}>
                                    <div className="star-rating-s15-wrapper">
                                        <span className={`star-rating-s15 rate-${Math.round(rating * 2)}`}/>
                                    </div>
                                    <span className="total-rating-out-five">{rating.toFixed(1)}</span>
                                    <span className="total-rating">({ratingsCount})</span>
                                </span>
                            }
                            {showOrdersInQueue &&
                                <span className="orders-in-queue">
                                    <I18n k="gig_page_perseus.overview.orders_in_queue" params={{amount: ordersInQueue}}/>
                                </span>
                            }
                            {showFiverrChoiceBadge &&
                                <Tooltip content={<I18n k="gig_page_perseus.overview.fiverr_choice"/>}
                                    position={Tooltip.POSITIONS.BOTTOM}>
                                    <span className="fiverr-choice"/>
                                </Tooltip>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

GigOverview.propTypes = {
    overview: PropTypes.shape({
        gig: PropTypes.shape({
            title: PropTypes.string.isRequired,
            rating: PropTypes.number,
            ratingsCount: PropTypes.number,
            ordersInQueue: PropTypes.number
        }),
        categories: PropTypes.shape({
            category: PropTypes.shape({
                name: PropTypes.string,
                slug: PropTypes.string
            }),
            subCategory: PropTypes.shape({
                name: PropTypes.string,
                slug: PropTypes.string
            }),
            nestedSubCategory: PropTypes.shape({
                name: PropTypes.string,
                slug: PropTypes.string
            })
        }),
        seller: PropTypes.shape({
            id: PropTypes.number.isRequired,
            username: PropTypes.string,
            achievement: PropTypes.number,
            isPro: PropTypes.bool,
            hasProfilePhoto: PropTypes.bool,
            profilePhoto: PropTypes.string
        })
    }),
    studioInfo: PropTypes.object,
    scrollToSection: PropTypes.func,
    useStickyLayout: PropTypes.bool
};

GigOverview.defaultProps = {
    studioInfo: {}
};

GigOverview.contextTypes = {
    general: PropTypes.object,
    requestContext: PropTypes.object
};

export { GigOverview };
export default SafePureComponent(GigOverview);
